// Procurement Agent – Brand Colors and Theme Constants

export const COLORS = {
  primary: '#1D4ED8',      // Procurement blue (indigo-700)
  success: '#16A34A',      // Success green
  warning: '#D97706',      // Amber warning
  secondary: '#0F172A',    // Dark slate
  blue: '#1D4ED8',         // Brand blue alias
  // Vibrant chart colors
  chart: {
    blue: '#3B82F6',       // Bright Blue
    green: '#10B981',      // Emerald Green
    purple: '#8B5CF6',     // Purple
    pink: '#EC4899',        // Pink
    orange: '#F59E0B',      // Amber
    teal: '#14B8A6',       // Teal
    red: '#EF4444',        // Red
    indigo: '#6366F1',     // Indigo
    cyan: '#06B6D4',       // Cyan
    yellow: '#EAB308',     // Yellow
  },
  gray: {
    50: '#F5F5F5',
    100: '#E0E0E0',
    200: '#C0C0C0',
    300: '#A0A0A0',
    500: '#4C4C4C',
    600: '#404040',
    700: '#303030',
    900: '#1A1A1A',
  },
};

// Colorful palette for charts (ensures good contrast and visibility)
// Updated to match UI theme with better color harmony
export const CHART_COLORS = [
  '#1D4ED8',     // Primary blue
  '#16A34A',     // Green
  '#D97706',     // Amber
  '#7C3AED',     // Violet
  '#0891B2',     // Cyan
  '#DC2626',     // Red
  '#059669',     // Emerald
  '#9333EA',     // Purple
  '#EA580C',     // Orange
  '#0369A1',     // Sky blue
];

export const BRAND_NAME = 'Procurement Agent';
export const BRAND_TAGLINE = 'AI-Powered Procurement Intelligence';

